

















































import { BFormGroup, BFormInput, BFormTextarea } from "bootstrap-vue";
import engagePopover from "../../components/engagePopover.vue";
import stepHeader from "../components/stepHeader.vue";
import { ValidationProvider } from "vee-validate";
// @ts-ignore
import { required } from "@validations";
import { ref, watch } from "@vue/composition-api";
import useEngageForm from "@/views/modules/engage/useEngageForm";

export default {
    components: {
        engagePopover,
        stepHeader,
        ValidationProvider,
        BFormGroup,
        BFormInput,
        BFormTextarea,
    },
    data() {
        return {
            errors: [],
        };
    },
    emits: ["nameSelected"],
    setup(props, { emit }) {
        const { currentStep, selectedEngageToEdit } = useEngageForm();
        if (selectedEngageToEdit.value) {
            currentStep.value = {
                ...currentStep.value,
                messageName: selectedEngageToEdit.value.name,
                description: selectedEngageToEdit.value.description,
                isDone: true,
            };
        }
        const name = ref(currentStep.value.messageName);
        const description = ref(currentStep.value.description);

        watch(
            name,
            (newValue) => {
                emit("nameSelected", { name: newValue, description: description.value });
            },
            { immediate: true }
        );

        watch(
            description,
            (newValue) => {
                emit("nameSelected", { name: name.value, description: newValue });
            },
            { immediate: true }
        );

        return {
            required,
            name,
            description,
            currentStep,
        };
    },
};
